import type { EventEditFormValues } from '-/Event/EventEdit.types';
import * as Yup from 'yup';
import {
  MAXIMUM_EVENT_TEAM_COUNT,
  MAXIMUM_EVENT_TITLE_LENGTH,
  MAXIMUM_TEAM_TITLE_LENGTH,
  MINIMUM_EVENT_TITLE_LENGTH,
} from './constants';

const eventTypeMap: {
  [key: string]: {
    activeFields: Array<keyof EventEditFormValues>;
    validator: any;
    label: string;
  };
} = {
  game: {
    activeFields: [
      'parentId',
      'datetime',
      'title',
      'location',
      'notes',
      'teams',
    ],
    validator: Yup.object().shape({
      datetime: Yup.string().required('Required'),
      title: Yup.string().max(MAXIMUM_EVENT_TITLE_LENGTH),
      teams: Yup.array()
        .of(
          Yup.object().shape({
            title: Yup.string()
              .max(MAXIMUM_TEAM_TITLE_LENGTH)
              .notOneOf([''], 'Title cannot be blank')
              .required(),
          }),
        )
        .max(MAXIMUM_EVENT_TEAM_COUNT)
        .required(),
    }),
    label: 'Game',
  },
  group: {
    activeFields: [
      'parentId',
      'hasStandings',
      'title',
      'location',
      'notes',
      'teams',
    ],
    validator: Yup.object().shape({
      title: Yup.string()
        .max(MAXIMUM_EVENT_TITLE_LENGTH)
        .min(MINIMUM_EVENT_TITLE_LENGTH, 'Required')
        .required('Required'),
      teams: Yup.array()
        .of(
          Yup.object().shape({
            title: Yup.string()
              .max(MAXIMUM_TEAM_TITLE_LENGTH)
              .notOneOf([''], 'All teams slots must be filled.')
              .required(),
          }),
        )
        .max(MAXIMUM_EVENT_TEAM_COUNT)
        .required('Required'),
      parentId: Yup.string().required('Required'),
    }),
    label: 'Schedule',
  },
  organization: {
    activeFields: ['title', 'tagGroupId'],
    validator: Yup.object().shape({
      title: Yup.string()
        .max(MAXIMUM_EVENT_TITLE_LENGTH)
        .min(MINIMUM_EVENT_TITLE_LENGTH, 'Required')
        .required('Required'),
    }),
    label: 'Organization',
  },
};

export default eventTypeMap;
